import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';
import Upperbox from '../components/Upperbox';

export const Boir = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
     <Upperbox />
     <NavBar />
      <div className='tax-page'>
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">BOIR</h1>
            <Link to="/businessservicespage" className="tax-notification-body">Go Back</Link>
          </div>
        </div>

        <div className='tax-content-container'>
          <h1 className='tax-section-title'>
            Beneficial Ownership Information Report (BOIR) Services at Sumukha Tax Filers.
          </h1>
          <p className='tax-section-description'>
            In response to increasing concerns over transparency and the prevention of illicit activities, the Financial Crimes Enforcement Network (FinCEN) has introduced the Beneficial Ownership Information Report (BOIR) requirements. At Sumukha Tax Filers., we understand the complexities involved in filing this report and are here to assist businesses in complying with the regulations efficiently and accurately.
          </p>
          <h2 className='tax-subheading'>What is the Beneficial Ownership Information Report (BOIR)?</h2>
          <p className='tax-section-description'>
            The BOIR requires certain entities, including corporations and limited liability companies (LLCs), to disclose information about their beneficial owners. Beneficial owners are individuals who directly or indirectly own or control a certain percentage of the entity or who exercise significant control over it. The BOIR aims to provide greater transparency in business ownership to combat money laundering, tax evasion, and other financial crimes.
          </p>
          <h2 className='tax-subheading'>Why Choose Sumukha Tax Filers. for Your BOIR Compliance?</h2>
          <ul className='tax-section-description'>
            <li><strong>Expertise:</strong> Our team of experienced Certified Public Accountants (CPAs) and Enrolled Agents (EAs) is well-versed in the BOIR requirements and can help ensure your business complies with all necessary regulations.</li>
            <li><strong>Customized Solutions:</strong> We understand that each business is unique. We tailor our services to meet your specific needs and ensure accurate reporting of beneficial ownership information.</li>
            <li><strong>Comprehensive Support:</strong> From understanding the definitions of beneficial ownership to preparing and filing the report, we provide comprehensive support throughout the process.</li>
          </ul>
          <h2 className='tax-subheading'>Our BOIR Services</h2>
          <p className='tax-section-description'>
            At Sumukha Tax Filers., we offer a full range of services related to the Beneficial Ownership Information Report, including:
          </p>
          <ol className='tax-section-description'>
            <li><strong>Assessment of Reporting Requirements:</strong> We evaluate your business structure to determine whether you are required to file a BOIR and identify the necessary information to disclose.</li>
            <li><strong>Data Collection and Verification:</strong> Our team assists in gathering and verifying the required information about beneficial owners, including their names, addresses, and ownership percentages.</li>
            <li><strong>Preparation of the BOIR:</strong> We ensure that the BOIR is accurately completed, adhering to all regulatory requirements, and reflects the current ownership structure of your business.</li>
            <li><strong>Filing and Submission:</strong> We handle the filing and submission of the BOIR to the appropriate authorities, ensuring that all deadlines are met.</li>
            <li><strong>Ongoing Compliance Monitoring:</strong> We provide ongoing support to help your business remain compliant with any changes in beneficial ownership or regulatory requirements, including updates to the BOIR.</li>
            <li><strong>Consulting Services:</strong> Our CPAs and EAs offer guidance on best practices for beneficial ownership transparency and compliance, helping you understand your obligations under the law.</li>
          </ol>
          <h2 className='tax-subheading'>Get Started Today</h2>
          <p className='tax-section-description'>
            Ensuring compliance with the Beneficial Ownership Information Report can be complex, but Sumukha Tax Filers. is here to simplify the process for you. Our dedicated team of experts is committed to providing you with the support you need for accurate reporting and compliance. Contact us today to schedule a consultation and learn how we can assist with your BOIR compliance needs!
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};
export default Boir;